/**
 * @param {Header} header
 * @param {Header} commonHeader
 * @returns {Header['formatter']}
 */
const initFormatter = (header = {}) => {
    let { formatter } = header;

    if (!formatter) {
        formatter = (() => {
            switch (header.formatterType) {
                case "date": {
                    return (value) => value?.toDate?.() || value || "-";
                }
                case "datetime": {
                    return (value) => value?.toDateTime?.() || value || "-";
                }
                case "number": {
                    return (value) => value?.format?.(header.formatterDigits || 0) || value || 0;
                }

                default: {
                    return (value) => value ?? "-";
                }
            }
        })();
    }

    return (value, item) => ((header.formatterPrefix || "") + formatter.bind(item)(value, item) + (header.formatterSuffix || "")).trim();
};

/**
 *
 * @param {Header[]} headers
 * @param {Header} [commonHeader]
 * @returns {Header[]}
 */
export const initDataTableHeaders = (headers = [], commonHeader = {}) => {
    headers = headers.filter((item) => item.shows ?? true);
    return headers.map((header, index, array) => ({
        ...commonHeader,
        ...header,

        sortable: header.sortable ?? commonHeader.sortable ?? false,

        divider: header.divider ?? commonHeader.divider ?? index != array.length - 1,

        formatter: initFormatter(header),

        class: ((header.class || commonHeader.class || "") + " line-height-1-3 white-space-pre-line").trim(),
        cellClass: ((header.cellClass || commonHeader.cellClass || "") + " caption line-height-1-5 white-space-pre-line").trim(),
    }));
};

/**
 * @typedef {Header_Default & Header_Custom} Header
 */
/**
 * @typedef {import("vuetify/types").DataTableHeader<any>} Header_Default
 */
/**
 * @typedef {object} Header_Custom
 * @property {'date'|'datetime'|'decimal'|'number'|'per-1mt'} formatterType
 * @property {string} formatterPrefix
 * @property {string} formatterSuffix
 * @property {number} formatterDigits
 * @property {function} formatter
 * @property {boolean} [shows]
 */
